import {
	Id,
	LaravelResponse,
	UploadFile,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { IClippingDetailResource, IClippingIndexResource, IClippingRequest } from "../types";

const baseKey = "clippings";
const fileKey = (clippingId: Id) => [baseKey, `${clippingId}`, "file"];

export const clippingsService = {
	...withShowEndpoint<IClippingDetailResource>([baseKey]),
	...withIndexEndpoint<IClippingIndexResource>([baseKey]),
	...withStoreEndpoint<IClippingRequest>([baseKey]),
	...withUpdateEndpoint<IClippingRequest>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	fileUploadKey: fileKey,
	uploadFile: async (clippingId: Id, file: UploadFile) => {
		const formData = new FormData();
		file.file && formData.append("file", file.file);
		return axios.post<LaravelResponse<void>>(keyToUrl(fileKey(clippingId)), formData);
	},
	deleteFile: async (clippingId: Id) => {
		return axios.delete<LaravelResponse<void>>(keyToUrl(fileKey(clippingId)));
	},
};

export const entityClippingsService = (entityName: string, entityId: Id) => {
	return {
		...withIndexEndpoint<IClippingIndexResource>([entityName, `${entityId}`, baseKey]),
		...withShowEndpoint<IClippingDetailResource>([baseKey]),
	};
};
